import store from '../store'
(function (win) {
    var doc = win.document
    var docEl = doc.documentElement
    var tid
   
    function refreshRem () {
      var width = docEl.getBoundingClientRect().width
        var userAgentInfo = navigator.userAgent;
        var Agents = ["Android", "iPhone",
            "SymbianOS", "Windows Phone", "iPod"];
        var isPc = true;
        for (var v = 0; v < Agents.length; v++) {
            if (userAgentInfo.indexOf(Agents[v]) > 0) {
              isPc = false;
                break;
            }
        }
        if(isPc){
          store.commit('setIspc',1)
        }else{
          store.commit('setIspc',0)
          
        }
        if(isPc){
          if (width < 600) {// 最大宽度
            width=600
          }
          var rem = width / 19.2
          docEl.style.fontSize = rem + 'px'
        }else{
          var rem = width / 7.8
          docEl.style.fontSize = rem + 'px'
        }
      
   
      
   
      // 当显示屏分辨率为1920*1080，且UI设计图尺寸为1920*1080
      // 可设置根元素大小为10px，如下：
      // docEl.style.fontSize = width / 192
      // 实际使用：字体大小16px，为1.6rem
    }
   
    win.addEventListener(
      'resize',
      function () {
        //当调整浏览器窗口大小时，发生 resize 事件。
        // console.log('浏览器窗口大小发生变化resize~~')
        this.clearTimeout(tid)
        tid = this.setTimeout(refreshRem, 300)
      },
      false
    )
    win.addEventListener(
      'pageshow',
      function (e) {
        //事件在每次加载页面时触发,类似于 onload 事件
        // console.log('页面加载事件pageshow~~')
        if (e.persisted) {
          this.clearTimeout(tid)
          tid = this.setTimeout(refreshRem, 300)
        }
      },
      false
    )
   
    refreshRem()
  })(window)


// WEBPACK FOOTER //
// ./src/utils/rem.js